import { StrictMode, Component, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import Header from './components/Header.jsx'
import Footer from './components/Footer.jsx'
import BarraNavInferior from './components/BarraNavInferior.jsx'
import { Toaster } from 'sileo'
import 'sileo/styles.css'

const CheckoutPage = lazy(() => import('./pages/CheckoutPage.jsx'));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage.jsx'));
const CheckoutRejectedPage = lazy(() => import('./pages/CheckoutRejectedPage.jsx'));
const LoginPage = lazy(() => import('./pages/LoginPage.jsx'));
const MyAccountPage = lazy(() => import('./pages/MyAccountPage.jsx'));
const AdminApp = lazy(() => import('./admin/AdminApp.jsx'));
const ComercioApp = lazy(() => import('./empresario/EmpresarioApp.jsx'));
const CheckinApp = lazy(() => import('./checkin/CheckinApp.jsx'));

function PublicLayout({ children }) {
  return (
    <>
      <Toaster position="top-center" />
      <Header />
      <main className="main-publico">{children}</main>
      <Footer />
      <BarraNavInferior />
    </>
  );
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('APP CRASH:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: 'monospace', color: '#ff4444', background: '#1a1a1a', minHeight: '100vh' }}>
          <h1>Error de React</h1>
          <pre style={{ whiteSpace: 'pre-wrap', color: '#ff8888' }}>{this.state.error?.toString()}</pre>
          <pre style={{ whiteSpace: 'pre-wrap', color: '#888', fontSize: 12, marginTop: 20 }}>{this.state.error?.stack}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient();

function LazyFallback() {
  return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', fontFamily: 'Plus Jakarta Sans, sans-serif', color: '#64748b' }}>Cargando...</div>;
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<Suspense fallback={<LazyFallback />}><AdminApp /></Suspense>} />
          <Route path="/panel-comercio/*" element={<Suspense fallback={<LazyFallback />}><ComercioApp /></Suspense>} />
          <Route path="/qr/*" element={<Suspense fallback={<LazyFallback />}><CheckinApp /></Suspense>} />
          <Route path="/login" element={<Suspense fallback={null}><PublicLayout><LoginPage /></PublicLayout></Suspense>} />
          <Route path="/mi-cuenta" element={<Suspense fallback={null}><PublicLayout><MyAccountPage /></PublicLayout></Suspense>} />
          <Route path="/checkout/gracias" element={<Suspense fallback={null}><ThankYouPage /></Suspense>} />
          <Route path="/checkout/rechazado" element={<Suspense fallback={null}><CheckoutRejectedPage /></Suspense>} />
          <Route path="/checkout/:slug" element={<Suspense fallback={null}><CheckoutPage /></Suspense>} />
          <Route path="*" element={<App />} />
        </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
